<div class="overlay" *ngIf="active">
    <img src="assets/aumico_loader_rings.png" alt="Loading..." />
</div>
